<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container text-center">
        <div class="navbar-header">
          <router-link class="navbar-brand" to="/admin">Grab Console</router-link>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">

              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <global-messages/>
                <form @submit.prevent="submitForm">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Forgotten Password</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Email address</label>
                        <input type="email" placeholder="Enter email" class="form-control input-no-border" v-model="form.email">
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit" class="btn btn-fill btn-wd ">Reset password</button>
                      <div class="forgot">
                        <router-link to="/login">
                          Back to login
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container"></div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import GlobalMessages from "../../../UIComponents/Messages";

export default {
  components: {GlobalMessages},
  data () {
    return {
      form: {
        email: '',
      }
    }
  },
  methods: {
    ...mapActions(['retrievePassword']),
    submitForm: async function () {
      await this.retrievePassword(this.form);//.then((data) => console.log(data));
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    }
  },
  beforeDestroy () {
    this.closeMenu()
  }
}
</script>
<style scoped>
.navbar-header {
  float: none;
  margin: 40px auto;
}

.navbar-brand {
  float: none;
}

.forgot {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/ForgotPassword.vue